/*
 * File: Home.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 16 Nov 2021 1:27:51 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Col, Divider, Row } from 'antd';
import { SalesOrderFilters } from 'components/molecules/SalesOrderFilters';
import { SalesOrderGrid } from 'components/molecules/SalesOrderGrid';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React from 'react';

const styles: InlineStylesModel = {
  divider: {
    margin: '9px 0px'
  }
};

export const Home = (): JSX.Element => {
  return (
    <Row>
      <Col span={24}>
        <SalesOrderFilters />
      </Col>
      <Divider style={styles.divider} />
      <Col span={24}>
        <SalesOrderGrid />
      </Col>
    </Row>
  );
};
